import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Divider } from "@react-md/divider";
import AppContext from '../context';
import { spotFooter } from '../images/spots';
import {
    Telegram,
    Instagram,
    Facebook,
    YouTube,
    HonestPeopleRu,
    HonestPeopleBy,
    HonestPeopleEn,
    HonestUniversity
} from '../images/socialNetworks';

export const Footer = () => {
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        setTimeout(() => {
          setIsShown(true);
        }, 500);
      }, []);
    

    const honestPeople = {
        'ru': <HonestPeopleRu className="link hp"/>,
        'by': <HonestPeopleBy className="link hp"/>,
        'en': <HonestPeopleEn className="link hp"/>,
    }

    return (
        <AppContext.Consumer>
            {({language, translations, links, screenSize}) => (
                <div id="actions" style={{}}>
                    {! screenSize.mobile && isShown && <img src={spotFooter} className='spot-footer' alt="spot" /> } 
                    <div className='content'>
                        {! screenSize.mobile &&  <Divider className="divider steps"/> }
                        <div className="table section" style={{marginTop: 0}}>
                            <p className="text text-grey" style={{width: '100%'}}>
                                {translations.footer.note}
                            </p>
                        </div>
                        <div className="table social-networks">
                            <div className={classNames("links", {"column": ! screenSize.mobile})}>
                                <a href={links.telegram} target="_blank" rel="noreferrer" className="link"><Telegram className="link social-network telegram" /></a>
                                <a href={links.instagram} target="_blank" rel="noreferrer" className="link"><Instagram className="link social-network instagram"/></a>
                                <a href={links.facebook} target="_blank" rel="noreferrer" className="link"><Facebook className="link social-network facebook"/></a>
                                <a href={links.youtube} target="_blank" rel="noreferrer" className="link"><YouTube className="link social-network youtube"/></a>
                            </div>
                            <div className={classNames("links", {"column": ! screenSize.mobile})}>
                                <a href={links.honestPeople[language]} target="_blank" rel="noreferrer" className="link">
                                    {honestPeople[language]}
                                </a>
                                <HonestUniversity className="link hu"/>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </AppContext.Consumer>
    )
};
